import { put, race, delay } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  set
} from '../redux/unreadBoardActivitiesCount'

export default function * fetchUnreadBoardsActivities (action) {
  const { boardIds } = action.payload

  try {
    const getDataPromise = apiGetData('UnreadBoardsActivitiesCount', {
      ids: boardIds
    })

    const { getDataResult, timeout } = yield race({
      getDataResult: getDataPromise,
      timeout: delay(30000)
    })

    if (timeout) {
      getDataPromise.cancel()
    }

    if (getDataResult) {
      const { Counts } = getDataResult

      yield put(boardIds.map(id => set({
        id,
        count: Counts.find(Count => Count.Id === id)?.C || 0,
      })))
    }
  } catch (e) {} // eslint-disable-line no-empty
}
